import axios from "axios";
import { clearTokens, getToken, login, refresh } from "../auth/auth";

const http = axios.create({
  baseURL: "/api",
});

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const newToken = await refresh();
        original.headers.Authorization = `Bearer ${newToken}`;
        return http(original);
      } catch {
        clearTokens();
        await login();
      }
    }

    return Promise.reject(error);
  },
);

export default http;
